function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { isTextNode } from '@cloud-sn/v-utils';
import Icon from '../icon';
import { buildComponentName } from '../utils';
var regTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var sizeMapping = {
  small: 'sm',
  large: 'lg'
};

function insertSpace() {
  var vnodes = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var ret = vnodes;

  if (vnodes.length === 1) {
    var node = vnodes[0];

    if (isTextNode(node)) {
      if (regTwoCNChar.test(node.text)) {
        node.text = node.text.split('').join(' ');
      }
    } else {
      node.children = insertSpace(node.children);
    }
  }

  return ret;
}

export default {
  name: buildComponentName('Button'),
  props: {
    prefixCls: {
      type: String,
      default: 'ux-btn'
    },
    type: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['', 'primary', 'ghost', 'dashed', 'danger'].indexOf(val) > -1;
      }
    },
    shape: {
      type: String,
      default: '',
      validator: function validator(val) {
        return ['', 'circle', 'circle-outline'].indexOf(val) > -1;
      }
    },
    size: {
      type: String,
      default: 'default',
      validator: function validator(val) {
        return ['small', 'default', 'large', ''].indexOf(val) > -1;
      }
    },
    loading: {
      type: [Boolean, Object],
      default: false
    },
    htmlType: {
      type: String,
      default: 'button',
      validator: function validator(val) {
        return ['button', 'submit', 'reset'].indexOf(val) > -1;
      }
    },
    icon: {
      type: String,
      default: ''
    },
    ghost: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      isMounted: false,
      innerLoading: false,
      clicked: false,
      timeout: null,
      delayTimeout: null
    };
  },
  computed: {
    sizeType: function sizeType() {
      var size = this.size;
      return sizeMapping[size];
    },
    classes: function classes() {
      var _ref;

      var prefixCls = this.prefixCls,
          type = this.type,
          shape = this.shape,
          sizeType = this.sizeType,
          innerLoading = this.innerLoading,
          clicked = this.clicked,
          ghost = this.ghost;
      return _ref = {}, _defineProperty(_ref, prefixCls, true), _defineProperty(_ref, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_ref, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_ref, "".concat(prefixCls, "-").concat(sizeType), !!sizeType), _defineProperty(_ref, "".concat(prefixCls, "-loading"), !!innerLoading), _defineProperty(_ref, "".concat(prefixCls, "-clicked"), !!clicked), _defineProperty(_ref, "".concat(prefixCls, "-background-ghost"), !!ghost), _ref;
    },
    bindProps: function bindProps() {
      var $props = this.$props;
      return _objectSpread({}, $props);
    },
    iconType: function iconType() {
      var icon = this.icon,
          innerLoading = this.innerLoading;
      return innerLoading ? 'loading' : icon;
    },
    iconNode: function iconNode() {
      var h = this.$createElement;
      var iconType = this.iconType;
      return iconType ? h(Icon, {
        "attrs": {
          "type": iconType
        }
      }) : null;
    }
  },
  watch: {
    loading: function loading() {
      this.initLoading();
    }
  },
  created: function created() {
    this.initLoading();
  },
  mounted: function mounted() {
    this.isMounted = true;
  },
  beforeDestroy: function beforeDestroy() {
    var timeout = this.timeout,
        delayTimeout = this.delayTimeout;

    if (timeout) {
      clearTimeout(timeout);
    }

    if (delayTimeout) {
      clearTimeout(delayTimeout);
    }
  },
  methods: {
    initLoading: function initLoading() {
      var _this = this;

      var loading = this.loading,
          delayTimeout = this.delayTimeout;

      if (delayTimeout) {
        clearTimeout(delayTimeout);
      }

      if (typeof loading !== 'boolean' && loading && loading.delay) {
        this.delayTimeout = setTimeout(function () {
          _this.innerLoading = loading;
        }, loading.delay);
      } else {
        this.innerLoading = !!loading;
      }
    },
    onClick: function onClick(e) {
      var _this2 = this;

      this.clicked = true;
      this.timeout = setTimeout(function () {
        _this2.clicked = false;
      }, 500);
      this.$emit('click', e);
    },
    getSlotNode: function getSlotNode(slotNode) {
      var h = this.$createElement;

      if (!slotNode) {
        return null;
      }

      return slotNode.map(function (v) {
        if (isTextNode(v)) {
          return h("span", [v]);
        }

        return v;
      });
    },
    getListeners: function getListeners() {
      var innerLoading = this.innerLoading,
          $listeners = this.$listeners,
          onClick = this.onClick;

      var listeners = _objectSpread({}, $listeners, {
        click: onClick
      });

      return Object.keys(listeners).reduce(function (r, k) {
        var nr = r;
        var fn = listeners[k];

        nr[k] = function () {
          if (innerLoading) {
            return;
          }

          fn.apply(void 0, arguments);
        };

        return nr;
      }, {});
    }
  },
  render: function render() {
    var h = arguments[0];
    var $slots = this.$slots,
        prefixCls = this.prefixCls,
        classes = this.classes,
        bindProps = this.bindProps,
        href = this.href,
        icon = this.icon,
        iconType = this.iconType,
        htmlType = this.htmlType,
        iconNode = this.iconNode,
        getSlotNode = this.getSlotNode,
        getListeners = this.getListeners;
    var attrs = {
      type: htmlType
    };
    var Cmp = 'button';

    if (href) {
      Cmp = 'a';
      attrs.href = href;
      delete attrs.type;
    }

    var on = getListeners();
    var slotDefault = $slots.default;
    slotDefault = slotDefault && (!iconType || iconType === 'loading') ? insertSpace(slotDefault) : slotDefault;

    var slotClasses = _defineProperty({}, "".concat(prefixCls, "-icon-only"), !slotDefault && icon);

    var slotNode = getSlotNode(slotDefault);
    return h(Cmp, {
      "class": [classes, slotClasses],
      "attrs": _objectSpread({}, attrs),
      "props": _objectSpread({}, bindProps),
      "on": _objectSpread({}, on)
    }, [iconNode, slotNode]);
  }
};